const RecommendedCarouselElement = document.querySelector(".recommended-by-slider__init");
RecommendedCarouselElement &&
    document.addEventListener("DOMContentLoaded", function () {
        var RecommendedCarousel = new Splide(".recommended-by-slider__init", {
            type: "loop",
            perPage: 6.2,
            perMove: 1,
            focus: "center",
            pagination: !1,
            padding: "10%",
            flickMaxPages: 7,
            classes: {
                arrows: "splide__arrows recommended-slider-arrows__container",
                arrow: "splide__arrow",
                prev: "splide__arrow--prev recommended-slider-arrow__prev",
                next: "splide__arrow--next recommended-slider-arrow__next",
            },
            breakpoints: {
                1600: { perPage: 4.4, pagination: !0 },
                1200: { perPage: 3.4, pagination: !0 },
                901: { perPage: 3, pagination: !0 },
                767: { perPage: 2.8, pagination: !0 },
                599: { perPage: 2.2, pagination: !0 },
                499: { perPage: 2.2, pagination: !0 },
                449: { perPage: 2, pagination: !0 },
            },
        }).mount();
        RecommendedCarousel.on("move", function (newIndex, prevIndex, destIndex) {
            var CarouselCounterContainer = document
                .querySelector(".recommended-by-slider__init")
                .querySelector(".splide__pagination-index");
            CarouselCounterContainer.querySelector(".splide-slide__current-index").innerHTML = newIndex;
        }),
            RecommendedCarousel.on("active", function (Slide) {
                var CurrentActiveSlide = Slide.slide,
                    SlideVideoElement = CurrentActiveSlide.querySelector(".recommended-slide__video");
                if (document.querySelector(".recommended-by-slider-pause-js")) {
                    let AutoPlayVideos2 = function (e) {
                        document.querySelector(".recommended-by-slider-pause-js") &&
                            (CurrentActiveSlide.querySelector(".recommended-slide__video").click(),
                            document
                                .querySelector(".recommended-by-slider__init")
                                .classList.remove("recommended-by-slider-pause-js"));
                    };
                    var AutoPlayVideos = AutoPlayVideos2,
                        activityEventsHH = [
                            "mousedown",
                            "mousemove",
                            "keydown",
                            "scroll",
                            "touchstart",
                            "click",
                            "keypress",
                            "touchmove",
                        ];
                    activityEventsHH.forEach(function (event) {
                        window.addEventListener(event, AutoPlayVideos2);
                    });
                } else CurrentActiveSlide.querySelector(".recommended-slide__video").click();
                SlideVideoElement.addEventListener("ended", function () {
                    var GoToNextIndex = CurrentActiveSlide + 1;
                    RecommendedCarousel.go("+${i}");
                });
            }),
            RecommendedCarousel.on("inactive", function (Slide) {
                var CurrentInActiveSlide = Slide.slide;
                CurrentInActiveSlide.querySelector(".recommended-slide__video").classList.remove("playVideo"),
                    CurrentInActiveSlide.querySelector(".recommended-slide__video").pause();
            });
    });